export default __webpack_public_path__ + "images/BB.c65c5b0.png";